import { FC } from 'react'
import {
  StyleHeaderImageWrapper,
  StyleHeaderWrapper,
  StyleHeaderMessageActionsWrapper,
  StyleHeaderMessageAction,
} from './style'
import Image from '@components/image'
import Typography from '@components/typography'
import Svg from '@components/svg'
import { useSelector } from 'react-redux'
import Helper from '@utils/helper'
interface MesageHeaderProps {
  receiver: any
  sender: any
}
const MesageHeader: FC<MesageHeaderProps> = ({ receiver }) => {
  const { data: user } = useSelector((state: any) => state.user)
  const room = useSelector((state: any) => state.room)
  return (
    <StyleHeaderWrapper>
      <StyleHeaderImageWrapper>
        <Image
          src="/"
          fallbackType="user"
          height={40}
          width={40}
          styleImage="border-radius:50%"
        />
        <Typography size={14} content={receiver?.name} />
      </StyleHeaderImageWrapper>
      <StyleHeaderMessageActionsWrapper>
        <StyleHeaderMessageAction
          onClick={async () => {
            Helper.saveCallSession({
              callType: 'video',
              receiver: receiver,
              type: 'outgoing',
              conversationId: room?.id,
              callSenderId: user?.id,
              callReceiverId: receiver?.id,
            })
            window.open(`/${user?.role}/call`, '_blank')
          }}
        >
          <Svg svg="video" size={30} />
        </StyleHeaderMessageAction>
        <StyleHeaderMessageAction
          onClick={() => {
            Helper.saveCallSession({
              callType: 'audio',
              receiver: receiver,
              type: 'outgoing',
              conversationId: room?.id,
              callSenderId: user?.id,
              callReceiverId: receiver?.id,
            })
            window.open(`/${user?.role}/call`, '_blank')
          }}
        >
          <Svg svg="call" size={30} />
        </StyleHeaderMessageAction>
      </StyleHeaderMessageActionsWrapper>
    </StyleHeaderWrapper>
  )
}

export default MesageHeader
